import { defineStore } from 'pinia'
import { getUserMenuList, login } from '@/api/modules/common'
import { resetDynamicRoutes } from '@/router'

export const useUserStore = defineStore('user', () => {
  const token = ref(localStorage.getItem('token') || '')
  const userInfo = ref<any>(JSON.parse(localStorage.getItem('userInfo') || 'null'))
  const menus = ref<any[]>(JSON.parse(localStorage.getItem('menus') || '[]'))

  const fetchMenus = async () => {
    const res: any = (await getUserMenuList() as any) || {}
    menus.value = res.menus || []
    localStorage.setItem('userInfo', JSON.stringify(res.user || {}))
    localStorage.setItem('menus', JSON.stringify(res.menus || []))
  }

  const loginAction = async (loginForm: any) => {
    const { accessToken, refreshToken, ...rest } = await login(loginForm) as any
    token.value = accessToken
    userInfo.value = rest
    localStorage.setItem('token', accessToken)
    localStorage.setItem('refreshToken', refreshToken)
    localStorage.setItem('userInfo', userInfo.value)
    await fetchMenus()
  }

  const logout = () => {
    localStorage.clear()
    token.value = ''
    userInfo.value = {}
    resetDynamicRoutes()
  }

  const loadUserInfo = () => {
    userInfo.value = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const savedMenus = localStorage.getItem('menus')
    if (savedMenus) menus.value = JSON.parse(savedMenus)
  }

  return {
    token,
    userInfo,
    menus,
    loginAction,
    logout,
    loadUserInfo,
    fetchMenus
  }
})
